import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { TcDaviviendaComponent } from './tc-davivienda/tc-davivienda.component';
import { TcDaviviendaRoutes } from './tc-davivienda.routing';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatSelectModule} from '@angular/material/select';
import { TcFormComponent } from './tc-form/tc-form.component';
import { TcHomeComponent } from './tc-home/tc-home.component';
import { NoTcDaviviendaComponent } from './no-tc-davivienda/no-tc-davivienda.component';
import { UseDaviviendaCardsComponent } from './use-davivienda-cards/use-davivienda-cards.component';
import { MatRadioModule } from '@angular/material/radio';
import { LibTbButtonModule, LibTbModalNotificationModule } from 'tech-block-lib';
import { CreditCardCarouselComponent } from './credit-card-carousel/credit-card-carousel.component';
import { SharedModule } from '@modules/shared.module';

@NgModule({
  imports: [
    CommonModule,
    TcDaviviendaRoutes,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatSelectModule,
    MatRadioModule,
    LibTbModalNotificationModule,
    LibTbButtonModule,
    SharedModule
  ],
  declarations: [
    TcDaviviendaComponent,
    TcFormComponent,
    TcHomeComponent,
    NoTcDaviviendaComponent,
    UseDaviviendaCardsComponent,
    CreditCardCarouselComponent
  ]
})
export class TcDaviviendaModule { }
